export default {
    init() {
        // JavaScript to be fired on the about us page
        const container = jQuery('main.main .media-container');
        container.isotope({
            filter: '*',
        });
        const filters = jQuery('main.main form.filters select');
        filters.on('change', (event) => {
            const selector = [];
            const data = jQuery(event.currentTarget).parents('form').serializeArray();
            jQuery.each(data, (index, item) => {
                if (item.value !== '' && item.value !== '*') {
                    selector.push(`[data-${item.name}*="${item.value}"]`);
                }
            });
            container.isotope({
                filter: selector.join(''),
            });
            container.on('arrangeComplete', () => {
                jQuery(window).trigger('scroll');
                jQuery('a[data-rel^="prettyPhoto"]', container).unbind('click');
                jQuery('a[data-rel^="prettyPhoto"]:visible', container).prettyPhoto({
                    hook: 'data-rel',
                    social_tools: false,
                    theme: 'pp_woocommerce',
                    horizontal_padding: 20,
                    opacity: 0.8,
                    deeplinking: false,
                });
            });
        });
        setTimeout(() => {
            filters.eq(0).trigger('change');
        }, 1000);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Gallery.js